import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: state => state.currentUser,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'currentUserIsAdmin',
    'currentUserCanManageSettings',
    'currentUserCanManagePermissions',
    'currentUserCanManageRoles',
    'currentUserCanManageUsers',
    'currentUserCanImportFiles',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'register',
  'logOut',
  'forgotPassword',
  'resetPassword',
])

export const facilityMethods = mapActions('facilities', [
  'facilityAdd',
  'changeFacility',
])

export const dashboardComputed = {
  ...mapState('dashboard', {
    cachedFacilityCodingMetrics: state => state.facilityCodingMetrics,
  }),
}

export const dashboardMethods = mapActions('dashboard', [
  'codingMetrics',
  'requestCreatedChartData',
  'pendingRequestCounts',
])

export const cdmMethods = mapActions('cdm', [
  'uploadCdms',
  'uploadRevUsage',
  'getCdms',
  'getCdm',
  'getOnlyCdms',
  'getRevUsage',
  'getRevUsageFields',
  'getInvalidCoding',
])
export const cdmrMethods = mapActions('cdmrs', [
  'cdmrAdd',
  'createCdmr',
  'createPurgeCdmr',
  'createChangeset',
  'getCdmr',
  'getOnlyCdmrs',
  'denyCdmr',
  'scriptCdmrs',
  'getInbox',
  'approveCdmr',
])
export const parseOptionsMethods = mapActions('parseOptions', [
  'updateOption',
  'getOptions',
])
export const cdmFieldsMethods = mapActions('cdmFields', [
  'updateField',
  'getFields',
  'updateFieldOrder',
  'updateRevField',
  'updateRevFieldOrder',
])
export const settingsMethods = mapActions('settings', [
  'getSettings',
  'getApproverWorkflows',
])
export const userMethods = mapActions('users', [
  'fetchUser',
  'getUsers',
  'inviteUser',
  'updateUser',
])
export const roleMethods = mapActions('roles', [
  'getRoles',
  'addRole',
  'updateRole',
  'addUsersToRole',
  'removeUsersFromRole',
  'deleteRole',
  'getRolesWithoutWorkflow',
])
export const permissionMethods = mapActions('permissions', [
  'getPermissions',
  'addPermission',
  'updatePermission',
  'deletePermission',
  'userRoleSearch',
])
export const approverWorkflowMethods = mapActions('approverWorkflow', [
  'getApprovers',
  'createApprover',
  'updateApproverOrder',
  'deleteApprover',
  'addApproverToWorkflow',
  'deleteSignoff',
  'getApprover',
])
